import React from 'react';
import { Slider, SliderTrack, SliderThumb } from 'react-aria-components';
import Text from '@amzn/meridian/text';
import { TuningSliderProps } from '../model';

const TuningSlider: React.FC<TuningSliderProps> = ({ value, disabled, maxSliderValue, onChange }) => {
  const effectiveMax = maxSliderValue ?? 200;
  const isModified = value !== 100;
  const displayLabel = value >= effectiveMax ? `${effectiveMax}%` : value <= 0 ? '0%' : `${value}%`;

  return (
    <div className="slider-container">
      <Slider
        minValue={0}
        maxValue={effectiveMax}
        step={5}
        value={value}
        onChange={onChange}
        isDisabled={disabled}
        aria-label="Tuning slider"
        style={{ flex: 1 }}
      >
        <SliderTrack
          style={{
            position: 'relative',
            height: '5px',
            width: '100%',
            borderRadius: '3px',
            background: disabled
              ? 'var(--mdn-color-gray-100, #E9EBEF)'
              : isModified
                ? '#fdeaea'
                : 'var(--mdn-color-gray-200, #CCD5DE)',
            opacity: disabled ? 0.4 : 1,
          }}
        >
          <SliderThumb
            style={{
              width: '14px',
              height: '14px',
              borderRadius: '50%',
              background: isModified
                ? '#c90202'
                : 'var(--mdn-color-blue-500, #00688D)',
              border: '2px solid var(--mdn-color-gray-0, #fff)',
              boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
              cursor: disabled ? 'not-allowed' : 'grab',
              top: '50%',
            }}
          />
        </SliderTrack>
      </Slider>
      <Text type="b100" color={isModified ? undefined : 'secondary'}>
        <span className={`slider-percent-label ${isModified ? 'slider-percent-label--modified' : ''}`}>
          {displayLabel}
        </span>
      </Text>
    </div>
  );
};

export default TuningSlider;
